import React from 'react';
import { IShopContent } from '../models/shop';
import localizedRoute from '../utils/localizedRoute';
import PrimaryButtonSmall from './PrimaryButtonSmall';

const ShopCard: React.FC<Partial<IShopContent>> = ({
  title,
  image,
  buttons = []
}) => {
  return (
    <div className="shop__card relative overflow-hidden rounded-lg">
      <img
        className="transition transform duration-500 hover:scale-105 pointer-events-auto"
        src={image}
        alt={title}
      />

      <div className="z-10 absolute right-0 bottom-0 flex flex-col justify-center items-center w-full p-16">
        <p className="text-4xl text-white mb-2 font-sans uppercase">{title}</p>

        <div
          className={`grid grid-cols-1 gap-4 uppercase lg:grid-cols-2 xl:grid-cols-${
            buttons.length > 2 ? '3' : buttons.length
          }`}
        >
          {buttons.map(({ title, url }, idx) => (
            <PrimaryButtonSmall
              key={idx}
              text={title}
              href={localizedRoute(url)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShopCard;
